/**
 * @description Tabela de GAUSS para ajuste das fases da LUA no calendário Gregoriano
 * @see https://www.inf.ufrgs.br/~cabral/Pascoa.html
 */
export const GAUSS_TABLE = [
  { yi: 1582, yf: 1599, p: { x: 22, y: 2 } },
  { yi: 1600, yf: 1699, p: { x: 22, y: 2 } },
  { yi: 1700, yf: 1799, p: { x: 23, y: 3 } },
  { yi: 1800, yf: 1899, p: { x: 24, y: 4 } },
  { yi: 1900, yf: 2099, p: { x: 24, y: 5 } },
  { yi: 2100, yf: 2199, p: { x: 24, y: 6 } },
  { yi: 2200, yf: 2299, p: { x: 25, y: 7 } },
];

export const HOLIDAY_FIXED = [
  {
    DAY: 1,
    MONTH: 0, // janeiro
    NAME: {
      US: "New Year's Day",
      BR: 'Confraternização Universal',
    },
  },
  {
    DAY: 21,
    MONTH: 3, // abril
    NAME: {
      US: 'Tiradentes',
      BR: 'Dia de Tiradentes',
    },
  },
  {
    DAY: 1,
    MONTH: 4, // maio
    NAME: {
      US: 'Labour Day',
      BR: 'Dia do Trabalhador',
    },
  },
  {
    DAY: 7,
    MONTH: 8, // setembro
    NAME: {
      US: 'Independence Day',
      BR: 'Dia da Independência',
    },
  },
  {
    DAY: 12,
    MONTH: 9, // outubro
    NAME: {
      US: 'Children´s Day',
      BR: 'Nossa Senhora Aparecida',
    },
  },
  {
    DAY: 2,
    MONTH: 10, // novembro
    NAME: {
      US: 'Day of the Dead',
      BR: 'Dia de Finados',
    },
  },
  {
    DAY: 15,
    MONTH: 10, // novembro
    NAME: {
      US: 'Republic Proclamation Day',
      BR: 'Proclamação da República',
    },
  },
  {
    DAY: 25,
    MONTH: 11, // dezembro
    NAME: {
      US: 'Christmas Day',
      BR: 'Natal',
    },
  },
];

export const HOLIDAY_LUNAR = {
  CA: {
    US: 'Carnival',
    BR: 'Carnaval',
  },
  GF: {
    US: 'Good Friday',
    BR: 'Sexta feira Santa',
  },
  ES: {
    US: 'Easter Sunday',
    BR: 'Domingo de Pascoa',
  },
  CC: {
    US: 'Corpus Christi',
    BR: 'Corpus Christi',
  },
};

export default {
  GAUSS_TABLE,
  HOLIDAY_FIXED,
  HOLIDAY_LUNAR,
};
